import React from 'react';

// Greenia AI "sparkles" mark — the modern assistant symbol, drawn as two
// four-point stars. Scales with the parent's font-size and inherits its color.
function GreeniaMark({ className = '' }) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M11.5 2.2c.15 3.03.9 4.6 2.05 5.75s2.72 1.9 5.75 2.05c-3.03.15-4.6.9-5.75 2.05s-1.9 2.72-2.05 5.75c-.15-3.03-.9-4.6-2.05-5.75S6.73 10.15 3.7 10c3.03-.15 4.6-.9 5.75-2.05S11.35 5.23 11.5 2.2Z" />
      <path d="M18.6 13.6c.08 1.55.46 2.35 1.05 2.95s1.4.97 2.95 1.05c-1.55.08-2.35.46-2.95 1.05s-.97 1.4-1.05 2.95c-.08-1.55-.46-2.35-1.05-2.95s-1.4-.97-2.95-1.05c1.55-.08 2.35-.46 2.95-1.05s.97-1.4 1.05-2.95Z" />
    </svg>
  );
}

export default GreeniaMark;
